import React from 'react';
import '../NotFound.css';

function NotFound() {
  return (
    <div className="not-found-container">
      <header className="not-found-header">
        <div className="not-found-logo-container">
          <img 
            src="https://lezzoo.com/images/Group.png" 
            alt="Lezzoo" 
            className="not-found-logo" 
          />
        </div>
      </header>
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for does not exist.</p>
      </div>
    </div>
  );
}

export default NotFound;
